const css = `.survey-round-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 24px;
  border-radius: 16px;
  background: var(--surface-raised);
  border: 1px solid var(--border);
}
.survey-round-status.is-active {
  border-color: var(--round-live-border);
  background: linear-gradient(90deg, var(--round-live-tint) 0%, var(--surface-raised) 60%);
}
.survey-round-status .survey-round-status-info {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}
.survey-round-status .survey-round-status-info h2 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
}
.survey-round-status .survey-round-status-info p {
  margin: 4px 0 0;
  font-size: var(--font-size-sm);
  color: var(--text-muted);
}
.survey-round-status .survey-round-status-dot {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--border-strong);
}
.survey-round-status.is-active .survey-round-status-dot {
  background: var(--round-live-dot);
  box-shadow: 0 0 0 0 var(--success-glow);
  animation: survey-round-pulse 2s infinite;
}
.survey-round-status .survey-round-status-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.survey-round-status .survey-round-status-blocker.p-button {
  min-width: 0;
  max-width: 100%;
  padding: 0;
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  text-align: left;
}
.survey-round-status .survey-round-status-blocker.p-button .p-button-label {
  white-space: normal;
  overflow-wrap: anywhere;
}
@media (max-width: 600px) {
  .survey-round-status {
    padding: 16px;
  }
  .survey-round-status .survey-round-status-actions {
    width: 100%;
    justify-content: flex-start;
  }
  .survey-round-status .survey-round-status-actions #survey-start-button,
  .survey-round-status .survey-round-status-actions #survey-stop-button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .survey-round-status.is-active .survey-round-status-dot {
    animation: none;
  }
}

@keyframes survey-round-pulse {
  0% {
    box-shadow: 0 0 0 0 var(--success-glow);
  }
  70% {
    box-shadow: 0 0 0 10px transparent;
  }
  100% {
    box-shadow: 0 0 0 0 transparent;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
